var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogoLoadsmart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "131px",
    height: "22px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 130.73 21.95",
    id: "LS_logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "LS_symbol_Green",
    "data-name": "LS symbol Green",
    viewBox: "0 0 208.77 208.77"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14d64d",
    d: "M73.46,0V65.72h65.72A3.87,3.87,0,0,1,143,69.59v65.72h65.72V7.73A7.73,7.73,0,0,0,201,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14d64d",
    d: "M65.72,139.19V3.87L2.26,67.33A7.73,7.73,0,0,0,0,72.8V201a7.72,7.72,0,0,0,7.72,7.72H136a7.73,7.73,0,0,0,5.47-2.26L204.91,143H69.59A3.86,3.86,0,0,1,65.72,139.19Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14d64d",
    id: "LS_text",
    d: "M128.61,14.05V10.83h2.12V7.94h-2.12V3.78l-3.09,1.63v8.67c0,3.53,1.17,4.7,4.76,4.7h.45V16c-1.89,0-2.12-.26-2.12-2m-6-3.23h2V7.94h-1.24a3.2,3.2,0,0,0-3.11,1.78V7.94h-3.07V18.78h3.09V13.66c0-2,.72-2.84,2.37-2.84m-10.18,8h3.09V7.94h-3.09V9a4.61,4.61,0,0,0-3.36-1.28,5.39,5.39,0,0,0-5.48,5.63A5.46,5.46,0,0,0,109,19a4.47,4.47,0,0,0,3.4-1.43Zm.09-5.44a2.87,2.87,0,0,1-2.89,2.93,2.92,2.92,0,1,1,0-5.83,2.85,2.85,0,0,1,2.89,2.9m-13.2,5.44h3.13V12.17c0-2.8-1.42-4.44-4.28-4.44a4.34,4.34,0,0,0-3.52,1.71,4.19,4.19,0,0,0-6.47-.35V7.94H85.11V18.78H88.2V12.86c0-1.82.86-2.6,2-2.6,1.38,0,2,.85,2,2.3v6.22h3.13V12.86c0-1.82.86-2.6,2-2.6,1.38,0,2,.85,2,2.3ZM77.47,11c0-.48.45-.89,1.47-.89A2.12,2.12,0,0,1,81,11.35l2.73-1.11C82.93,8.72,81.49,7.73,79,7.73c-2.8,0-4.62,1.58-4.62,3.4,0,2.32,2,3,4.06,3.34,1.31.24,2.41.41,2.41,1s-.54,1-1.56,1A2.36,2.36,0,0,1,76.89,15l-3,1.11C74.75,18,76.39,19,79.12,19c3.25,0,4.78-2,4.78-3.62,0-2.34-2.19-3-4.08-3.36-1.69-.32-2.34-.5-2.34-1M70,18.78h3.09V3H70V9a4.61,4.61,0,0,0-3.36-1.28,5.39,5.39,0,0,0-5.48,5.63A5.46,5.46,0,0,0,66.6,19,4.47,4.47,0,0,0,70,17.56Zm.09-5.44a2.87,2.87,0,0,1-2.89,2.93,2.92,2.92,0,1,1,0-5.83,2.85,2.85,0,0,1,2.89,2.9M56.9,18.78H60V7.94H56.9V9a4.61,4.61,0,0,0-3.36-1.28,5.39,5.39,0,0,0-5.48,5.63A5.46,5.46,0,0,0,53.49,19a4.47,4.47,0,0,0,3.4-1.43ZM57,13.34a2.87,2.87,0,0,1-2.89,2.93,2.92,2.92,0,1,1,0-5.83A2.85,2.85,0,0,1,57,13.34m-9.87,0a5.84,5.84,0,0,0-11.68,0,5.84,5.84,0,0,0,11.68,0m-3,0a2.83,2.83,0,0,1-2.84,2.82,2.82,2.82,0,1,1,0-5.63,2.83,2.83,0,0,1,2.84,2.82m-13,5.42h3.09V3H31.14Z"
  }), /*#__PURE__*/React.createElement("use", {
    width: 208.77,
    height: 208.77,
    transform: "scale(0.11)",
    xlinkHref: "#LS_symbol_Green"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoLoadsmart);
export default __webpack_public_path__ + "static/media/icon_logo_loadsmart.b5edd583615157c24eaa03c8bd63264b.svg";
export { ForwardRef as ReactComponent };